import React from "react";
import { Navigate } from "react-router-dom";

export default function Discovery() {
  return <Navigate to="/" replace />;
}
